import React from 'react';
import { BaseEdge, EdgeProps, getBezierPath } from 'reactflow';

import { getEdgeColor } from '../dag/styles';
import { useDagContext } from '../dbt-dag';
import { useInternalDagContext } from '../providers/InternalDagProvider';

const X_OFFSET = 4;

type BasicEdgeComponentProps = EdgeProps<any>;

const BLACK_ARROWHEAD_MARKER = "url('#black-right-arrow')";

export const BasicEdgeComponentImpl: React.ComponentType<BasicEdgeComponentProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}) => {
  const defaultData = { hasArrowhead: true, strokeWidth: 1, ...data };
  const {
    highlight: isHighlighted,
    hasArrowhead,
    isHidden,
    dbtCloudProject,
    isError,
    targetProject,
    isExternalNode,
  } = defaultData;
  const [edgePath] = getBezierPath({
    sourceX: sourceX - X_OFFSET,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const { grain = 'project', activeDbtCloudProject } = useInternalDagContext();
  const { selectedNode } = useDagContext();

  const opacity = isHidden ? 0.2 : !isHighlighted && selectedNode ? 0.3 : 1;
  const targetDbtCloudProject = targetProject?.dbtCloudProject;
  const isExternal =
    ['project', 'column'].includes(grain) &&
    !!activeDbtCloudProject &&
    ((!!dbtCloudProject && activeDbtCloudProject !== dbtCloudProject) ||
      (!!targetDbtCloudProject && activeDbtCloudProject !== targetDbtCloudProject));

  return (
    <>
      <BaseEdge
        style={{
          strokeWidth: 1,
          stroke: getEdgeColor({ isHighlighted, isError }),
          strokeDasharray: isExternal || isExternalNode ? '5 4' : undefined,
          strokeLinecap: isExternal || isExternalNode ? 'round' : undefined,
          pointerEvents: 'none',
          ...style,
          opacity,
        }}
        id={id}
        path={edgePath}
        markerEnd={hasArrowhead ? BLACK_ARROWHEAD_MARKER : markerEnd}
      />
    </>
  );
};

const BasicEdgeDisplay = React.memo(BasicEdgeComponentImpl);

export const BasicEdgeComponent: React.ComponentType<BasicEdgeComponentProps> = (
  props,
) => {
  return <BasicEdgeDisplay {...props} />;
};
